import React from 'react';
import { useForm } from "react-hook-form";

export const ManageRoleForm = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = (data) => {
        let addData = {
            roleName: data.roleName,
            creationDate: today,
            roleDescription: data.roleDes,
        }
        console.log(addData);
    }
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    <div className="co-lg-6 col-md-6">
                        <h6>Role Name</h6>
                        <input className="form-control " placeholder="Group Name"     {...register("roleName", { required: true })} />
                        <small className="mb-2 text-muted">Role Name, Used for oraganization</small> <br />
                        {errors.roleName && <span className="text-danger">This field is required</span>}
                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6 >Creation Date</h6>
                        <input className="form-control " disabled value={today} {...register("creationDate")} />
                        <small className="mb-2 text-muted">The Role was created on the following date</small>

                    </div>
                    <div className="co-lg-12 col-md-12 mt-3">
                        <h6 >Role Description</h6>
                        <input className="form-control  " placeholder="Group Description"  {...register("roleDes", { required: true })} />
                        <small className="mb-2 text-muted">Description of the Role</small> <br />
                        {errors.roleDes && <span className="text-danger">This field is required</span>}
                    </div>
                </div>
                <div className="dataTableSubmitBtn">
                    <input className="btn btn-success" value="Submit" type="submit" />
                </div>
            </form>

        </>

    );
};
export const ManageRolesEditDetails = ({ userDetails }) => {

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) => {
        let EditData = {
            roleName: data.roleName,
            creationDate: today,
            roleDescription: data.roleDes,
        }
        console.log(EditData);
    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    <div className="co-lg-6 col-md-6">
                        <h6>Role Name</h6>
                        <input className="form-control " placeholder="Group Name" defaultValue={userDetails.name}    {...register("roleName", { required: true })} />
                        <small className="mb-2 text-muted">Role Name, Used for oraganization</small> <br />
                        {errors.roleName && <span className="text-danger">This field is required</span>}
                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6 >Creation Date</h6>
                        <input className="form-control " disabled defaultValue={today} {...register("creationDate")} />
                        <small className="mb-2 text-muted">The Role was created on the following date</small>

                    </div>
                    <div className="co-lg-12 col-md-12 mt-3">
                        <h6 >Role Description</h6>
                        <input className="form-control  " placeholder="Group Description" defaultValue={userDetails.description} {...register("roleDes", { required: true })} />
                        <small className="mb-2 text-muted">Description of the Role</small> <br />
                        {errors.roleDes && <span className="text-danger">This field is required</span>}
                    </div>
                </div>
                <div className="dataTableSubmitBtn">
                    <input className="btn btn-success" value="Submit" type="submit" />
                </div>
            </form>

        </>
    )
}
